import React, { useState, useEffect ,useRef} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight, faList } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { configData } from "../config";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
 import { format } from "date-fns";
import "./classes/SalesReport.css";
import { useReactToPrint } from "react-to-print";

const API_BASE = configData.APP_URL;

const SalesReport = () => {
    const mockData = [
        {
            transaction_id: 101,
            invoice_number: "INV-2026-001",
            customer_name: "Rahul Sharma",
            total_amount: 18500,
            order_date: "2026-02-18T10:15:00",
            items: [
            {
                item_name: "Sports Shoes",
                quantity: 2,
                unit_price: 3500,
                total: 7000
            },
            {
                item_name: "Cricket Bat",
                quantity: 1,
                unit_price: 6500,
                total: 6500
            },
            {
                item_name: "Gym Bag",
                quantity: 1,
                unit_price: 5000,
                total: 5000
            }
            ]
        },
        {
            transaction_id: 102,
            invoice_number: "INV-2026-002",
            customer_name: "Anjali Verma",
            total_amount: 9200,
            order_date: "2026-02-17T14:30:00",
            items: [
            {
                item_name: "Yoga Mat",
                quantity: 2,
                unit_price: 1200,
                total: 2400
            },
            {
                item_name: "Dumbbell Set",
                quantity: 1,
                unit_price: 6800,
                total: 6800
            }
            ]
        },
        {
            transaction_id: 103,
            invoice_number: "INV-2026-003",
            customer_name: "Mohit Patel",
            total_amount: 15400,
            order_date: "2026-02-16T09:45:00",
            items: [
            {
                item_name: "Football",
                quantity: 3,
                unit_price: 900,
                total: 2700
            },
            {
                item_name: "Goalkeeper Gloves",
                quantity: 2,
                unit_price: 1850,
                total: 3700
            },
            {
                item_name: "Training Jersey",
                quantity: 4,
                unit_price: 2250,
                total: 9000
            }
            ]
        },
        {
            transaction_id: 104,
            invoice_number: "INV-2026-004",
            customer_name: "Sneha Kapoor",
            total_amount: 4800,
            order_date: "2026-02-15T16:20:00",
            items: []
        }
    ];
    const initialForm = {  
        start_date:'',
        start_date_obj:null,
        end_date:'',
        end_date_obj:null,
        customer_name: ''
    };     

    const [formData, setFormData] = useState(initialForm);
    const [submittedData, setSubmittedData] = useState(null);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [sales, setSales] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedId, setExpandedId] = useState(null);
    const [orderItems, setOrderItems] = useState({});

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    // const [searchCustomer, setSearchCustomer] = useState("");
    const [options, setOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const customers = [
        { id: 1, name: "Rahul Sharma" },
        { id: 2, name: "Anjali Verma" },
        { id: 3, name: "Mohit Patel" },
        { id: 4, name: "Sneha Kapoor" },
    ];
    const [formErrors, setFormErrors] = useState({}); 
    // useEffect(() => {
    //     const handler = setTimeout(() => {
    //     if (searchCustomer.trim() === "") {
    //         setOptions([]);
    //         return;
    //     }
    //     setOptions(customers.filter(p => p.name.includes(searchCustomer.toLowerCase())));
    //     }, 300);

    //     return () => clearTimeout(handler);
    // }, [searchCustomer]);

    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({
        contentRef: contentRef,
        documentTitle: "Sales Report",
    });

    const contentOrderRef = useRef(null);

    const handleOrderPrint = useReactToPrint({
    contentRef: contentOrderRef,
    documentTitle: selectedInvoice
        ? `Invoice-${selectedInvoice.invoice_number}`
        : "Invoice",
    });

    const printSale = (sale) => {
        setSelectedInvoice(sale);
        setTimeout(() => {
            handleOrderPrint();
        }, 0);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (date, field) => {
        setFormData(prev => ({
            ...prev,
            [`${field}_obj`]: date,                     
            [field]: date ? format(date, "yyyy-MM-dd") : '' 
        }));
    };


  const validateDates = (formData) => {
    let errors = {};

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }

    return errors;
  };
  const fetchSales = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}sales/report`);
      const data = await res.json();
      let list = [];
      if (Array.isArray(data)) list = data;
      else if (data?.data && Array.isArray(data.data)) list = data.data;
      else if (data?.sales && Array.isArray(data.sales)) list = data.sales;
      setSales(list);
    } catch (error) {
      console.error("Error fetching sales:", error);
      setSales([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderItems = async (transactionId, sale) => {
    if (orderItems[transactionId]) return;
    const inlineItems = sale?.items ?? sale?.order_items ?? sale?.orderItems;
    if (Array.isArray(inlineItems) && inlineItems.length > 0) {
      setOrderItems((prev) => ({ ...prev, [transactionId]: inlineItems }));
      return;
    }
    try {
      const res = await fetch(`${API_BASE}sales/orders/${transactionId}`);
      const data = await res.json();
      let items = [];
      if (Array.isArray(data)) items = data;
      else if (data?.data && Array.isArray(data.data)) items = data.data;
      else if (data?.items && Array.isArray(data.items)) items = data.items;
      setOrderItems((prev) => ({ ...prev, [transactionId]: items }));
    } catch (error) {
      console.error("Error fetching order items:", error);
      setOrderItems((prev) => ({ ...prev, [transactionId]: [] }));
    }
  };

  const toggleOrders = (transactionId, sale) => {
    setExpandedId((prev) => (prev === transactionId ? null : transactionId));
    fetchOrderItems(transactionId, sale);
  };

  useEffect(() => {
    fetchSales();
  }, []);
    // useEffect(() => {
    //     setLoading(true);
    //     setTimeout(() => {
    //         setSales(mockData);
    //         setLoading(false);
    //     }, 800);
    // }, []);
    const handleSubmit = async (e) => {
        e.preventDefault(); // stop page reload

        const errors = validateDates(formData);

        if (Object.keys(errors).length > 0) {
            // console.log("Validation errors:", errors);
            setFormErrors(errors); 
            return;
        }
        setFormErrors({});
        console.log(formData);
        try {
        const response = await fetch(API_BASE+'', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                page: 0,
                pageSize: 50, 
                formData:formData
            }),
        });
        const data = await response.json();
        // console.log(data.data.rows);
        // setSales(data.rows);
        }  catch (error) {
                console.error('Error fetching data:', error);
            } finally {
            }
        console.log("Form submitted:", formData);
    };

    return (
        <div className="pos-main sales-report-page">
            <Helmet>
                <title>Sales Report</title>
            </Helmet>
            <div className="sales-report-container">
                <h2 className="sales-report-title">
                    <FontAwesomeIcon icon={faList} /> Sales Report
                </h2>
                <form onSubmit={handleSubmit}>
                    <div className="sales-report-filters">
                        <div className="order-search-container">
                            <label>Customer Name: </label>
                            {/* <Autocomplete
                                className=""
                                options={options}
                                getOptionLabel={(option) => option.name}
                                value={selectedCustomer}
                                inputValue={searchCustomer}
                                onInputChange={(e, value) => setSearchCustomer(value)}
                                onChange={(e, value) => {
                                    if (!value) return;
                                    setSelectedCustomer(value);
                                }}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                    <strong>{option.name}</strong>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    //inputRef={inputSearchRef}
                                    placeholder="Search Customers"
                                    //  onKeyDown={handleKeyDown}
                                    />
                                )}
                            /> */}
                            <input 
                                type="text"
                                name="customer_name"
                                value={formData.customer_name}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label htmlFor="start_date">Start Date: </label>
                            <DatePicker
                                ref={startDateRef}
                                selected={formData.start_date_obj}
                                onChange={(date) => {handleDateChange(date, 'start_date');
                                    setTimeout(() => {
                                        const input = startDateRef.current?.input;
                                        if (input) {
                                            const len = input.value.length;
                                            input.setSelectionRange(len, len);
                                        }
                                    }, 0);
                                }}
                                name="start_date"
                                id="start_date"
                                // required
                            /> 
                            <br /><br />
                            <label htmlFor="end_date">End Date: </label>

                            <DatePicker
                                ref={endDateRef}
                                selected={formData.end_date_obj}
                                onChange={(date) => {handleDateChange(date, 'end_date');
                                    setTimeout(() => {
                                        const input = endDateRef.current?.input;
                                        if (input) {
                                            const len = input.value.length;
                                            input.setSelectionRange(len, len);
                                        }
                                    }, 0);
                                }}
                                name="end_date"
                                id="end_date"
                                // required
                            />
                            {formErrors.end_date && (
                                <div className="error">{formErrors.end_date}</div>
                            )}
                        </div>
                        <div>
                            <input type="submit" value="Submit" className="orders-toggle-btn" />
                            <button className="orders-toggle-btn" onClick={() => {handlePrint();}}>Print</button>
                        </div>
                    </div>
                </form>
                {loading ? (
                    <p className="sales-report-empty">Loading sales...</p>
                ) : sales.length === 0 ? (
                    <p className="sales-report-empty">No sales records found.</p>
                ) : (
                    <>
                    <div className="sales-report-table-wrapper">
                        <table className="sales-report-table desktop-sales-table">
                            <thead>
                                <tr>
                                <th>Transaction ID</th>
                                <th>Invoice #</th>
                                <th>Customer Name</th>
                                <th>Total</th>
                                <th>Date</th>
                                <th>Orders</th>
                                </tr>
                            </thead>
                            {sales.map((sale) => {
                                const id = sale.transaction_id ?? sale.id ?? sale.transaction_id;
                                const invoiceNumber = sale.invoice_number ?? sale.invoice_no ?? sale.invoice ?? "—";
                                const customerName = sale.customer_name ?? sale.customer ?? sale.customerName ?? "—";
                                const total = sale.total_amount ?? sale.total ?? sale.grand_total ?? 0;
                                const date = sale.order_date ?? sale.created_at ?? sale.date ?? sale.created ?? "";
                                const isExpanded = expandedId === id;
                                return (
                                    <tbody key={id}>
                                        {/* <React.Fragment> */}
                                        <tr>
                                            <td>{id}</td>
                                            <td>{invoiceNumber}</td>
                                            <td>{customerName}</td>
                                            <td>₹{Number(total).toFixed(2)}</td>
                                            <td>{date ? new Date(date).toLocaleString() : "—"}</td>
                                            <td>
                                            <button
                                                type="button"
                                                className="orders-toggle-btn"
                                                onClick={() => toggleOrders(id, sale)}
                                            >
                                                <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight} />
                                                View Orders
                                            </button>
                                            </td>
                                        </tr>
                                        {isExpanded && (
                                            <tr className="order-details-row">
                                                <td colSpan={6}>
                                                    <div className="order-details-panel">
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <h4>Order Items</h4>
                                                            <button className="orders-toggle-btn" style={{marginBottom: "5px"}} onClick={() => printSale(sale)}>
                                                                Print
                                                            </button>
                                                        </div>
                                                        {!orderItems[id] ? (
                                                            <p className="order-details-loading">Loading...</p>
                                                        ) : orderItems[id].length === 0 ? (
                                                            <p className="order-details-empty">No items in this order.</p>
                                                        ) : (
                                                            <table className="order-items-table">
                                                                <thead>
                                                                    <tr>
                                                                    <th>Item</th>
                                                                    <th>Qty</th>
                                                                    <th>Unit Price</th>
                                                                    <th>Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {orderItems[id].map((item, idx) => (
                                                                        <tr key={idx}>
                                                                            <td>{item.item_name ?? item.name ?? item.product ?? "—"}</td>
                                                                            <td>{item.quantity ?? item.qty ?? "—"}</td>
                                                                            <td>₹{Number(item.unit_price ?? item.unit_cost ?? 0).toFixed(2)}</td>
                                                                            <td>₹{Number(item.total ?? item.line_total ?? 0).toFixed(2)}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* </React.Fragment> */}
                                    </tbody>
                                );
                            })}
                        </table>
                        <table className="sales-report-table mobile-sales-table">
                            <thead>
                                <tr>
                                <th>Sales Details</th>
                                <th>Orders</th>
                                </tr>
                            </thead>
                            {sales.map((sale) => {
                                const id = sale.transaction_id ?? sale.id ?? sale.transaction_id;
                                const invoiceNumber = sale.invoice_number ?? sale.invoice_no ?? sale.invoice ?? "—";
                                const customerName = sale.customer_name ?? sale.customer ?? sale.customerName ?? "—";
                                const total = sale.total_amount ?? sale.total ?? sale.grand_total ?? 0;
                                const date = sale.order_date ?? sale.created_at ?? sale.date ?? sale.created ?? "";
                                const isExpanded = expandedId === id;
                                return (
                                    <tbody key={id}>
                                        {/* <React.Fragment> */}
                                        <tr>
                                            <td style={{fontSize: "12px"}}>
                                                Transaction ID: {id}<br />
                                                Invoice #: {invoiceNumber}<br />
                                                Customer Name: {customerName}<br />
                                                Total: ₹{Number(total).toFixed(2)}<br />
                                                Date: {date ? new Date(date).toLocaleString() : "—"}
                                            </td>
                                            <td>
                                            <button
                                                type="button"
                                                className="orders-toggle-btn"
                                                onClick={() => toggleOrders(id, sale)}
                                            >
                                                <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight} />
                                                View Orders
                                            </button>
                                            </td>
                                        </tr>
                                        {isExpanded && (
                                            <tr className="order-details-row">
                                                <td colSpan={2}>
                                                    <div className="order-details-panel">
                                                    <h4>Order Items</h4>
                                                    <button className="orders-toggle-btn" style={{marginBottom: "5px"}} onClick={() => printSale(sale)}>
                                                        Print
                                                    </button>
                                                    {!orderItems[id] ? (
                                                        <p className="order-details-loading">Loading...</p>
                                                    ) : orderItems[id].length === 0 ? (
                                                        <p className="order-details-empty">No items in this order.</p>
                                                    ) : (
                                                        <table className="order-items-table">
                                                            <thead>
                                                                <tr>
                                                                <th>Item</th>
                                                                <th>Total</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {orderItems[id].map((item, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>
                                                                            {item.item_name ?? item.name ?? item.product ?? "—"}<br />
                                                                            <span style={{fontSize: "12px"}}>
                                                                            Qty: {item.quantity ?? item.qty ?? "—"}<br />
                                                                            Unit Price: ₹{Number(item.unit_price ?? item.unit_cost ?? 0).toFixed(2)}
                                                                            </span>
                                                                        </td>
                                                                        <td>₹{Number(item.total ?? item.line_total ?? 0).toFixed(2)}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* </React.Fragment> */}
                                    </tbody>
                                );
                            })}
                        </table>
                    </div>
                    </>
                )}
            </div>
            <div ref={contentRef} className="printContent">
                <div style={{textAlign: "center"}}><h3>Sales Report</h3></div>
                <div className="sales-container">
                    <table className="sales-table">
                        <colgroup>
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "20%" }} />
                            <col style={{ width: "25%" }} />
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "25%" }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Transaction ID</th>
                                <th>Invoice #</th>
                                <th>Customer Name</th>
                                <th>Total</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        {sales.map((sale) => {
                            const id = sale.transaction_id ?? sale.id ?? sale.transaction_id;
                            const invoiceNumber = sale.invoice_number ?? sale.invoice_no ?? sale.invoice ?? "—";
                            const customerName = sale.customer_name ?? sale.customer ?? sale.customerName ?? "—";
                            const total = sale.total_amount ?? sale.total ?? sale.grand_total ?? 0;
                            const date = sale.order_date ?? sale.created_at ?? sale.date ?? sale.created ?? "";
                            const isExpanded = expandedId === id;
                            return (
                                <tbody key={id}>
                                    {/* <React.Fragment> */}
                                    <tr>
                                        <td>{id}</td>
                                        <td>{invoiceNumber}</td>
                                        <td>{customerName}</td>
                                        <td>₹{Number(total).toFixed(2)}</td>
                                        <td>{date ? new Date(date).toLocaleString() : "—"}</td>
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                </div>
            </div>

            <div ref={contentOrderRef} className="printContent">
                {selectedInvoice && (
                <div className="sales-container">
                    <div style={{float: "left"}}>
                        <p>Customer: {selectedInvoice.customer_name}</p>
                        <p>Invoice #: {selectedInvoice.invoice_number}</p>
                    </div>
                    <p style={{float: "right"}}>Date: {selectedInvoice.order_date}</p>
                    <div style={{clear: "both"}}></div>
                    <table className="sales-table">
                        <colgroup>
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "30%" }} />
                            <col style={{ width: "20%" }} />
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "25%" }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Sl No</th>
                                <th>Item</th>
                                <th>Qty</th>
                                <th>Unit Price</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(orderItems[selectedInvoice.sales_id] || []).map((item, idx) => (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{item.item_name ?? item.name ?? item.product ?? "—"}</td>
                                    <td>{item.quantity ?? item.qty ?? "—"}</td>
                                    <td>₹{Number(item.unit_price ?? item.unit_cost ?? 0).toFixed(2)}</td>
                                    <td>₹{Number(item.total ?? item.line_total ?? 0).toFixed(2)}</td>
                                </tr>
                            ))}
                            <tr style={{fontSize: "14px", fontWeight: "bold"}}><td colSpan={4}>TOTAL AMOUNT</td><td>₹{Number(selectedInvoice.total_amount).toFixed(2)}</td></tr>
                        </tbody>
                    </table>
                </div>
                )}
            </div>
        </div>
    );
};

export default SalesReport;